/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavReportColumnMapping = {
  column_index: number;
  column_name: string;
  kind: DailyNavReportColumnMapping.kind;
  field?: DailyNavReportColumnMapping.field;
  value?: string;
};
export namespace DailyNavReportColumnMapping {
  export enum kind {
    FIELD = 'field',
    LITERAL = 'literal',
  }
  export enum field {
    CURRENCY = 'currency',
    DAILY_NAV_NOTES = 'daily_nav_notes',
    FUND_NAME = 'fund_name',
    REPORT_DATE = 'report_date',
    SECURITY_IDENTIFIER = 'security_identifier',
    SECURITY_NAME = 'security_name',
    VALUATION_MEASUREMENT_DATE = 'valuation_measurement_date',
    VALUATION_PRICE_PER_SHARE = 'valuation_price_per_share',
  }
}

